export enum Transportart {
	Sonstig = 0,
	Verrechenbar = 1,
	Dienstfahrt = 2,
	Werkstattfahrt = 3,
	Gebietsabsicherung = 4,
	NA_VA_Zubringer = 5,
	NEF_Einsatz = 6,
	VEF_Einsatz = 7,
	NichtVerrechenbar = 8,
	Leerfahrt = 9,
}

export enum Einsatzart {
	KTP_zum_KH = 10,
	KTP_Verlegung = 11,
	KTP_Heimfahrt = 12,
	KTP_Ambulanzfahrt = 13,
	KTP_Ambulanzfahrt_genehmigt = 15,
	KTP_Dialyse = 16,
	KTP_Notfall = 17,
	KTP_Ambulanzfahrt_KV211 = 18,
	KTP_Sonstige = 19,
	KTP_Verlegung_HeimKHS = 90,
	KTP_MedTransport = 91,
	KTP_Transplantat = 93,
	KTP_BG_Unfall = 94,
	KTP_Sonstiger_Unfall = 95,
	KTP_Versorgungsleiden = 96,
	KTP_Serienfahrt = 98,
	// NF
	NF_Verkehrsunfall = 20,
	NF_Verlegung = 21,
	NF_Arbeitsunfall = 22,
	NF_Schulunfall = 23,
	NF_Verlegung_VRTW = 24,
	NF_Internistisch = 25,
	NF_Sonstiger_Unfall = 26,
	NF_kein_Transport_SonstNotfall = 27,
	NF_kein_Transport_Unfall = 28,
	NF_Sonstiger_Nofall = 29,
	NF_Neugeborenen_Holdienst = 92,
	NF_Verlegung_KVB = 97,
	NF_ITW = 99,
	// NA
	NA_Verkehrsunfall = 60,
	NA_Verlegung = 61,
	NA_Arbeitsunfall = 62,
	NA_Schulunfall = 63,
	NA_Internistisch = 65,
	NA_Sonstiger_Unfall = 66,
	NA_kein_Transport_Internistisch = 67,
	NA_kein_Transport_Unfall = 68,
	NA_Sonstiger_Notfall = 69,
}
